import { Button } from '../components/UI';
import { SiteFooter, SiteHeader } from '../components/Chrome';

export function ThanksPage() {
  return (
    <>
      <SiteHeader />
      <main>
        <section className="band-soft thanks-hero">
          <div className="site-wrap">
            <div className="sent-glyph" aria-hidden="true">✓</div>
            <div className="overline">Enquiry received</div>
            <h1>Thanks — I have your message.</h1>
            <p className="hero-sub">I will read through what you shared and work out the most useful next step. You do not need to understand the technical side or already know what solution you need.</p>
          </div>
        </section>
        <section className="site-wrap section">
          <div className="about-grid thanks-about">
            <div className="about-copy">
              <div className="overline">Who you are working with</div>
              <h2>Hi, I am Duncan.</h2>
              <p>I started Byte-Size to give local small businesses a practical person to call when technology is getting in the way. My job is to understand the problem, explain the options clearly and help choose the smallest sensible solution.</p>
              <p>Sometimes that means fixing something directly. Sometimes it means connecting existing tools, simplifying a process or helping you deal with another supplier. Either way, the conversation starts with what the business needs rather than a product I am trying to sell.</p>
              <Button as="a" href="/services/" variant="secondary" iconRight="→">See what Byte-Size helps with</Button>
            </div>
            <figure className="about-photo">
              <img src="/assets/duncan.webp" alt="Duncan, founder of Byte-Size" width="1000" height="1500" />
              <figcaption>Duncan — founder and problem-solver at Byte-Size</figcaption>
            </figure>
          </div>
        </section>
      </main>
      <SiteFooter />
    </>
  );
}
